import { isConcierge } from "../../users/accountRole"

// Maps the backend's `a2p_status.phase` (crm/a2p/status.py a2p_phase) to the
// SMS sending gate used across the portal.

export const A2P_REASONS = {
  brandPending: "brand_pending",
  brandFailed: "brand_failed",
  brandSuspended: "brand_suspended",
  otpPending: "otp_pending",
  registrationIncomplete: "registration_incomplete",
  campaignPending: "campaign_pending",
  campaignFailed: "campaign_failed",
  campaignSuspended: "campaign_suspended",
}

const PHASE_TO_REASON = {
  not_started: A2P_REASONS.registrationIncomplete,
  in_progress: A2P_REASONS.registrationIncomplete,
  campaign_needed: A2P_REASONS.registrationIncomplete,
  brand_pending: A2P_REASONS.brandPending,
  brand_failed: A2P_REASONS.brandFailed,
  brand_suspended: A2P_REASONS.brandSuspended,
  otp_pending: A2P_REASONS.otpPending,
  campaign_pending: A2P_REASONS.campaignPending,
  campaign_failed: A2P_REASONS.campaignFailed,
  campaign_suspended: A2P_REASONS.campaignSuspended,
}

/**
 * Gate from the backend phase. Returns null when the backend did not send a
 * phase (older API), so callers can fall back to the legacy check.
 */
export function smsGateFromA2PStatus(a2pStatus) {
  const phase = a2pStatus?.phase
  if (!phase) {
    return null
  }
  if (phase === "ready") {
    return { ready: true }
  }
  return {
    ready: false,
    reason: PHASE_TO_REASON[phase] || A2P_REASONS.registrationIncomplete,
  }
}

export const SOLE_PROPRIETOR = "SOLE_PROPRIETOR"

export function isSoleProprietor(a2pStatus) {
  return a2pStatus?.brand_type === SOLE_PROPRIETOR
}

export const A2P_10DLC_REG_STAGES = {
  not_attempted: "not_attempted_0",
  end_user_business_info: "end_user_business_info_1",
  end_user_repr_info: "end_user_repr_info_2",
  customer_profile_review_pending: "customer_profile_review_pending_3",
  trust_product_approved: "trust_product_approved_4",
  brand_registration_sent: "brand_registration_sent_5",
  a2p_campaign_created: "a2p_campaign_created_6",
}

/**
 * Mirrors SMS gating in the former candidate-flow dialogs: ready only when A2P
 * campaign exists and brand is not stuck in pending review.
 */
export function getSmsSendingPrerequisiteState(crmSettings, profile) {
  if (isConcierge(profile)) {
    if (!profile?.twilio_voice_phone) {
      return { ready: false, reason: "concierge_no_phone" }
    }
    return { ready: true }
  }
  const settings = crmSettings?.settings || {}
  // The backend reads the real brand/campaign state from Twilio and sends a
  // phase; trust that over the raw stored status (which used to be mixed up
  // between clients and left approved clients stuck at "brand pending").
  const gate = smsGateFromA2PStatus(settings.a2p_status)
  if (gate) {
    return gate
  }
  const regStage = settings.twilio_a2p_10dlc_reg_stage
  if (
    regStage === A2P_10DLC_REG_STAGES.brand_registration_sent &&
    settings.twilio_brand_reg_status !== "registered"
  ) {
    return { ready: false, reason: "brand_pending" }
  }
  if (regStage !== A2P_10DLC_REG_STAGES.a2p_campaign_created) {
    return { ready: false, reason: "registration_incomplete" }
  }
  return { ready: true }
}
